import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactInputMask from 'react-input-mask';
import { toTitleCase } from '../../utils/formatData';
import { useAppSelector } from '../../hooks/hooksRedux';
import { RootState } from '../../store';
import { defaultColors } from '../../styles/style-guide';

interface Props {
  label: string;
  id: string;
  error?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

interface Country {
  name: string;
  code: string;
}

const countriesCode = {
  'pt-BR': [
    { name: 'Afeganistão', code: '+93' },
    { name: 'África do Sul', code: '+27' },
    { name: 'Albânia', code: '+355' },
    { name: 'Alemanha', code: '+49' },
    { name: 'Andorra', code: '+376' },
    { name: 'Angola', code: '+244' },
    { name: 'Antígua e Barbuda', code: '+1-268' },
    { name: 'Arábia Saudita', code: '+966' },
    { name: 'Argélia', code: '+213' },
    { name: 'Argentina', code: '+54' },
    { name: 'Armênia', code: '+374' },
    { name: 'Austrália', code: '+61' },
    { name: 'Áustria', code: '+43' },
    { name: 'Azerbaijão', code: '+994' },
    { name: 'Bahamas', code: '+1-242' },
    { name: 'Bahrein', code: '+973' },
    { name: 'Bangladesh', code: '+880' },
    { name: 'Barbados', code: '+1-246' },
    { name: 'Belarus', code: '+375' },
    { name: 'Bélgica', code: '+32' },
    { name: 'Belize', code: '+501' },
    { name: 'Benin', code: '+229' },
    { name: 'Bermudas', code: '+1-441' },
    { name: 'Bolívia', code: '+591' },
    { name: 'Bósnia e Herzegovina', code: '+387' },
    { name: 'Botsuana', code: '+267' },
    { name: 'Brasil', code: '+55' },
    { name: 'Brunei', code: '+673' },
    { name: 'Bulgária', code: '+359' },
    { name: 'Burkina Faso', code: '+226' },
    { name: 'Burundi', code: '+257' },
    { name: 'Butão', code: '+975' },
    { name: 'Cabo Verde', code: '+238' },
    { name: 'Camarões', code: '+237' },
    { name: 'Camboja', code: '+855' },
    { name: 'Canadá', code: '+1' },
    { name: 'Catar', code: '+974' },
    { name: 'Cazaquistão', code: '+7' },
    { name: 'Chade', code: '+235' },
    { name: 'Chile', code: '+56' },
    { name: 'China', code: '+86' },
    { name: 'Chipre', code: '+357' },
    { name: 'Colômbia', code: '+57' },
    { name: 'Comores', code: '+269' },
    { name: 'Congo', code: '+242' },
    { name: 'Coreia do Norte', code: '+850' },
    { name: 'Coreia do Sul', code: '+82' },
    { name: 'Costa do Marfim', code: '+225' },
    { name: 'Costa Rica', code: '+506' },
    { name: 'Croácia', code: '+385' },
    { name: 'Cuba', code: '+53' },
    { name: 'Dinamarca', code: '+45' },
    { name: 'Djibuti', code: '+253' },
    { name: 'Dominica', code: '+1-767' },
    { name: 'Egito', code: '+20' },
    { name: 'El Salvador', code: '+503' },
    { name: 'Emirados Árabes Unidos', code: '+971' },
    { name: 'Equador', code: '+593' },
    { name: 'Eritreia', code: '+291' },
    { name: 'Eslováquia', code: '+421' },
    { name: 'Eslovênia', code: '+386' },
    { name: 'Espanha', code: '+34' },
    { name: 'Estados Unidos', code: '+1' },
    { name: 'Estônia', code: '+372' },
    { name: 'Eswatini', code: '+268' },
    { name: 'Etiópia', code: '+251' },
    { name: 'Fiji', code: '+679' },
    { name: 'Filipinas', code: '+63' },
    { name: 'Finlândia', code: '+358' },
    { name: 'França', code: '+33' },
    { name: 'Gabão', code: '+241' },
    { name: 'Gâmbia', code: '+220' },
    { name: 'Gana', code: '+233' },
    { name: 'Geórgia', code: '+995' },
    { name: 'Granada', code: '+1-473' },
    { name: 'Grécia', code: '+30' },
    { name: 'Guatemala', code: '+502' },
    { name: 'Guiana', code: '+592' },
    { name: 'Guiné', code: '+224' },
    { name: 'Guiné Equatorial', code: '+240' },
    { name: 'Guiné-Bissau', code: '+245' },
    { name: 'Haiti', code: '+509' },
    { name: 'Holanda', code: '+31' },
    { name: 'Honduras', code: '+504' },
    { name: 'Hungria', code: '+36' },
    { name: 'Iêmen', code: '+967' },
    { name: 'Ilhas Cayman', code: '+1-345' },
    { name: 'Ilhas Cook', code: '+682' },
    { name: 'Ilhas Marshall', code: '+692' },
    { name: 'Ilhas Salomão', code: '+677' },
    { name: 'Ilhas Virgens Americanas', code: '+1-340' },
    { name: 'Ilhas Virgens Britânicas', code: '+1-284' },
    { name: 'Índia', code: '+91' },
    { name: 'Indonésia', code: '+62' },
    { name: 'Irã', code: '+98' },
    { name: 'Iraque', code: '+964' },
    { name: 'Irlanda', code: '+353' },
    { name: 'Islândia', code: '+354' },
    { name: 'Israel', code: '+972' },
    { name: 'Itália', code: '+39' },
    { name: 'Jamaica', code: '+1-876' },
    { name: 'Japão', code: '+81' },
    { name: 'Jordânia', code: '+962' },
    { name: 'Kiribati', code: '+686' },
    { name: 'Kuwait', code: '+965' },
    { name: 'Laos', code: '+856' },
    { name: 'Lesoto', code: '+266' },
    { name: 'Letônia', code: '+371' },
    { name: 'Líbano', code: '+961' },
    { name: 'Libéria', code: '+231' },
    { name: 'Líbia', code: '+218' },
    { name: 'Liechtenstein', code: '+423' },
    { name: 'Lituânia', code: '+370' },
    { name: 'Luxemburgo', code: '+352' },
    { name: 'Madagascar', code: '+261' },
    { name: 'Malásia', code: '+60' },
    { name: 'Malawi', code: '+265' },
    { name: 'Maldivas', code: '+960' },
    { name: 'Mali', code: '+223' },
    { name: 'Malta', code: '+356' },
    { name: 'Marrocos', code: '+212' },
    { name: 'Maurício', code: '+230' },
    { name: 'Mauritânia', code: '+222' },
    { name: 'México', code: '+52' },
    { name: 'Micronésia', code: '+691' },
    { name: 'Moçambique', code: '+258' },
    { name: 'Moldávia', code: '+373' },
    { name: 'Mônaco', code: '+377' },
    { name: 'Mongólia', code: '+976' },
    { name: 'Montenegro', code: '+382' },
    { name: 'Namíbia', code: '+264' },
    { name: 'Nauru', code: '+674' },
    { name: 'Nepal', code: '+977' },
    { name: 'Nicarágua', code: '+505' },
    { name: 'Níger', code: '+227' },
    { name: 'Nigéria', code: '+234' },
    { name: 'Niue', code: '+683' },
    { name: 'Noruega', code: '+47' },
    { name: 'Nova Zelândia', code: '+64' },
    { name: 'Omã', code: '+968' },
    { name: 'Palau', code: '+680' },
    { name: 'Palestina', code: '+970' },
    { name: 'Panamá', code: '+507' },
    { name: 'Papua Nova Guiné', code: '+675' },
    { name: 'Paquistão', code: '+92' },
    { name: 'Paraguai', code: '+595' },
    { name: 'Peru', code: '+51' },
    { name: 'Polônia', code: '+48' },
    { name: 'Portugal', code: '+351' },
    { name: 'Quênia', code: '+254' },
    { name: 'Quirguistão', code: '+996' },
    { name: 'Reino Unido', code: '+44' },
    { name: 'República Centro-Africana', code: '+236' },
    { name: 'República Dominicana', code: '+1-809, +1-829, +1-849' },
    { name: 'República Tcheca', code: '+420' },
    { name: 'Romênia', code: '+40' },
    { name: 'Ruanda', code: '+250' },
    { name: 'Rússia', code: '+7' },
    { name: 'Samoa', code: '+685' },
    { name: 'San Marino', code: '+378' },
    { name: 'Santa Lúcia', code: '+1-758' },
    { name: 'São Cristóvão e Nevis', code: '+1-869' },
    { name: 'São Tomé e Príncipe', code: '+239' },
    { name: 'São Vicente e Granadinas', code: '+1-784' },
    { name: 'Senegal', code: '+221' },
    { name: 'Sérvia', code: '+381' },
    { name: 'Seychelles', code: '+248' },
    { name: 'Serra Leoa', code: '+232' },
    { name: 'Singapura', code: '+65' },
    { name: 'Síria', code: '+963' },
    { name: 'Somália', code: '+252' },
    { name: 'Sri Lanka', code: '+94' },
    { name: 'Suazilândia', code: '+268' },
    { name: 'Sudão', code: '+249' },
    { name: 'Sudão do Sul', code: '+211' },
    { name: 'Suécia', code: '+46' },
    { name: 'Suíça', code: '+41' },
    { name: 'Suriname', code: '+597' },
    { name: 'Tailândia', code: '+66' },
    { name: 'Taiwan', code: '+886' },
    { name: 'Tajiquistão', code: '+992' },
    { name: 'Tanzânia', code: '+255' },
    { name: 'Timor-Leste', code: '+670' },
    { name: 'Togo', code: '+228' },
    { name: 'Tonga', code: '+676' },
    { name: 'Trinidad e Tobago', code: '+1-868' },
    { name: 'Tunísia', code: '+216' },
    { name: 'Turcomenistão', code: '+993' },
    { name: 'Turquia', code: '+90' },
    { name: 'Tuvalu', code: '+688' },
    { name: 'Ucrânia', code: '+380' },
    { name: 'Uganda', code: '+256' },
    { name: 'Uruguai', code: '+598' },
    { name: 'Uzbequistão', code: '+998' },
    { name: 'Vanuatu', code: '+678' },
    { name: 'Vaticano', code: '+379' },
    { name: 'Venezuela', code: '+58' },
    { name: 'Vietnã', code: '+84' },
    { name: 'Zâmbia', code: '+260' },
    { name: 'Zimbábue', code: '+263' }
  ],
  en: [
    { name: 'Afghanistan', code: '+93' },
    { name: 'South Africa', code: '+27' },
    { name: 'Albania', code: '+355' },
    { name: 'Germany', code: '+49' },
    { name: 'Andorra', code: '+376' },
    { name: 'Angola', code: '+244' },
    { name: 'Antigua and barbuda', code: '+1-268' },
    { name: 'Saudi Arabia', code: '+966' },
    { name: 'Algeria', code: '+213' },
    { name: 'Argentina', code: '+54' },
    { name: 'Armenia', code: '+374' },
    { name: 'Australia', code: '+61' },
    { name: 'Austria', code: '+43' },
    { name: 'Azerbaijan', code: '+994' },
    { name: 'Bahamas', code: '+1-242' },
    { name: 'Bahrain', code: '+973' },
    { name: 'Bangladesh', code: '+880' },
    { name: 'Barbados', code: '+1-246' },
    { name: 'Belarus', code: '+375' },
    { name: 'Belgium', code: '+32' },
    { name: 'Belize', code: '+501' },
    { name: 'Benin', code: '+229' },
    { name: 'Bermudas', code: '+1-441' },
    { name: 'Bolivia', code: '+591' },
    { name: 'Bosnia and Herzegovina', code: '+387' },
    { name: 'Botswana', code: '+267' },
    { name: 'Brazil', code: '+55' },
    { name: 'Brunei', code: '+673' },
    { name: 'Bulgaria', code: '+359' },
    { name: 'Burkina Faso', code: '+226' },
    { name: 'Burundi', code: '+257' },
    { name: 'Bhutan', code: '+975' },
    { name: 'Cape Green', code: '+238' },
    { name: 'Cameroon', code: '+237' },
    { name: 'Cambodia', code: '+855' },
    { name: 'Canada', code: '+1' },
    { name: 'Qatar', code: '+974' },
    { name: 'Kazakhstan', code: '+7' },
    { name: 'Chad', code: '+235' },
    { name: 'Chile', code: '+56' },
    { name: 'China', code: '+86' },
    { name: 'Cyprus', code: '+357' },
    { name: 'Colombia', code: '+57' },
    { name: 'Comoros', code: '+269' },
    { name: 'Congo', code: '+242' },
    { name: 'North Korea', code: '+850' },
    { name: 'South Korea', code: '+82' },
    { name: 'Costa do Marfim', code: '+225' },
    { name: 'Costa Rica', code: '+506' },
    { name: 'Croatia', code: '+385' },
    { name: 'Cuba', code: '+53' },
    { name: 'Denmark', code: '+45' },
    { name: 'Djibuti', code: '+253' },
    { name: 'Dominica', code: '+1-767' },
    { name: 'Egypt', code: '+20' },
    { name: 'El Salvador', code: '+503' },
    { name: 'United Arab Emirates', code: '+971' },
    { name: 'Ecuador', code: '+593' },
    { name: 'Eritreia', code: '+291' },
    { name: 'Slovakia', code: '+421' },
    { name: 'Slovenia', code: '+386' },
    { name: 'Spain', code: '+34' },
    { name: 'U.S', code: '+1' },
    { name: 'Estonia', code: '+372' },
    { name: 'Eswatini', code: '+268' },
    { name: 'Ethiopia', code: '+251' },
    { name: 'Fiji', code: '+679' },
    { name: 'Philippines', code: '+63' },
    { name: 'Finland', code: '+358' },
    { name: 'France', code: '+33' },
    { name: 'Gabon', code: '+241' },
    { name: 'Gambia', code: '+220' },
    { name: 'Gana', code: '+233' },
    { name: 'Georgia', code: '+995' },
    { name: 'Granada', code: '+1-473' },
    { name: 'Greece', code: '+30' },
    { name: 'Guatemala', code: '+502' },
    { name: 'Guiana', code: '+592' },
    { name: 'Guinea', code: '+224' },
    { name: 'Equatorial Guinea', code: '+240' },
    { name: 'Guinea Bissau', code: '+245' },
    { name: 'Haiti', code: '+509' },
    { name: 'Netherlands', code: '+31' },
    { name: 'Honduras', code: '+504' },
    { name: 'Hungary', code: '+36' },
    { name: 'Yemen', code: '+967' },
    { name: 'Cayman Islands', code: '+1-345' },
    { name: 'cook islands', code: '+682' },
    { name: 'Marshall Islands', code: '+692' },
    { name: 'Solomon Islands', code: '+677' },
    { name: 'US Virgin Islands', code: '+1-340' },
    { name: 'british virgin islands', code: '+1-284' },
    { name: 'India', code: '+91' },
    { name: 'Indonesia', code: '+62' },
    { name: 'Iran', code: '+98' },
    { name: 'Iraq', code: '+964' },
    { name: 'Ireland', code: '+353' },
    { name: 'Iceland', code: '+354' },
    { name: 'Israel', code: '+972' },
    { name: 'Italy', code: '+39' },
    { name: 'Jamaica', code: '+1-876' },
    { name: 'Japan', code: '+81' },
    { name: 'Jordan', code: '+962' },
    { name: 'Kiribati', code: '+686' },
    { name: 'Kuwait', code: '+965' },
    { name: 'Laos', code: '+856' },
    { name: 'Lesoto', code: '+266' },
    { name: 'Latvia', code: '+371' },
    { name: 'Líbano', code: '+961' },
    { name: 'Libéria', code: '+231' },
    { name: 'Líbia', code: '+218' },
    { name: 'Liechtenstein', code: '+423' },
    { name: 'Lithuania', code: '+370' },
    { name: 'Luxembourg', code: '+352' },
    { name: 'Madagascar', code: '+261' },
    { name: 'Malaysia', code: '+60' },
    { name: 'Malawi', code: '+265' },
    { name: 'Maldives', code: '+960' },
    { name: 'Mali', code: '+223' },
    { name: 'Malta', code: '+356' },
    { name: 'Morocco', code: '+212' },
    { name: 'Mauritius', code: '+230' },
    { name: 'Mauritania', code: '+222' },
    { name: 'Mexico', code: '+52' },
    { name: 'Micronesia', code: '+691' },
    { name: 'Mozambique', code: '+258' },
    { name: 'Moldávia', code: '+373' },
    { name: 'Monaco', code: '+377' },
    { name: 'Mongolia', code: '+976' },
    { name: 'Montenegro', code: '+382' },
    { name: 'namibia', code: '+264' },
    { name: 'Nauru', code: '+674' },
    { name: 'Nepal', code: '+977' },
    { name: 'Nicaragua', code: '+505' },
    { name: 'Níger', code: '+227' },
    { name: 'Nigeria', code: '+234' },
    { name: 'Niue', code: '+683' },
    { name: 'Norway', code: '+47' },
    { name: 'New Zealand', code: '+64' },
    { name: 'Oman', code: '+968' },
    { name: 'Palau', code: '+680' },
    { name: 'Palestine', code: '+970' },
    { name: 'Panama', code: '+507' },
    { name: 'Papua New Guinea', code: '+675' },
    { name: 'Pakistan', code: '+92' },
    { name: 'Paraguay', code: '+595' },
    { name: 'Peru', code: '+51' },
    { name: 'Poland', code: '+48' },
    { name: 'Portugal', code: '+351' },
    { name: 'Kenya', code: '+254' },
    { name: 'Kyrgyzstan', code: '+996' },
    { name: 'UK', code: '+44' },
    { name: 'Central African Republic', code: '+236' },
    { name: 'Dominican Republic', code: '+1-809, +1-829, +1-849' },
    { name: 'Czech republic', code: '+420' },
    { name: 'Romania', code: '+40' },
    { name: 'Ruanda', code: '+250' },
    { name: 'Russia', code: '+7' },
    { name: 'Samoa', code: '+685' },
    { name: 'San Marino', code: '+378' },
    { name: 'Santa Lúcia', code: '+1-758' },
    { name: 'Saint Kitts and Nevis', code: '+1-869' },
    { name: 'Sao Tome and Principe', code: '+239' },
    { name: 'Saint Vincent and the Grenadines', code: '+1-784' },
    { name: 'Senegal', code: '+221' },
    { name: 'Serbia', code: '+381' },
    { name: 'Seychelles', code: '+248' },
    { name: 'Sierra Leone', code: '+232' },
    { name: 'Singapura', code: '+65' },
    { name: 'Syria', code: '+963' },
    { name: 'Somalia', code: '+252' },
    { name: 'Sri Lanka', code: '+94' },
    { name: 'Suazilândia', code: '+268' },
    { name: 'Sudan', code: '+249' },
    { name: 'Southern Sudan', code: '+211' },
    { name: 'Sweden', code: '+46' },
    { name: 'Switzerland', code: '+41' },
    { name: 'Suriname', code: '+597' },
    { name: 'thailand', code: '+66' },
    { name: 'Taiwan', code: '+886' },
    { name: 'Tajikistan', code: '+992' },
    { name: 'Tanzania', code: '+255' },
    { name: 'Timor-Leste', code: '+670' },
    { name: 'Togo', code: '+228' },
    { name: 'Tonga', code: '+676' },
    { name: 'Trinidad e Tobago', code: '+1-868' },
    { name: 'Tunisia', code: '+216' },
    { name: 'Turkmenistan', code: '+993' },
    { name: 'Türkiye', code: '+90' },
    { name: 'Tuvalu', code: '+688' },
    { name: 'Ukraine', code: '+380' },
    { name: 'Uganda', code: '+256' },
    { name: 'Uruguay', code: '+598' },
    { name: 'uzbekistan', code: '+998' },
    { name: 'Vanuatu', code: '+678' },
    { name: 'Vatican', code: '+379' },
    { name: 'Venezuela', code: '+58' },
    { name: 'Vietnam', code: '+84' },
    { name: 'Zambia', code: '+260' },
    { name: 'Zimbabwe', code: '+263' }
  ],
  es: [
    { name: 'Afganistán', code: '+93' },
    { name: 'Sudáfrica', code: '+27' },
    { name: 'Albania', code: '+355' },
    { name: 'Alemania', code: '+49' },
    { name: 'Andorra', code: '+376' },
    { name: 'Angola', code: '+244' },
    { name: 'Antigua y Barbuda', code: '+1-268' },
    { name: 'Arabia Saudita', code: '+966' },
    { name: 'Argelia', code: '+213' },
    { name: 'Argentina', code: '+54' },
    { name: 'Armenia', code: '+374' },
    { name: 'Australia', code: '+61' },
    { name: 'Austria', code: '+43' },
    { name: 'Azerbaiyán', code: '+994' },
    { name: 'Bahamas', code: '+1-242' },
    { name: 'Baréin', code: '+973' },
    { name: 'Bangladesh', code: '+880' },
    { name: 'Barbados', code: '+1-246' },
    { name: 'Bielorrusia', code: '+375' },
    { name: 'Bélgica', code: '+32' },
    { name: 'Belice', code: '+501' },
    { name: 'Benín', code: '+229' },
    { name: 'islas Bermudas', code: '+1-441' },
    { name: 'Bolivia', code: '+591' },
    { name: 'Bosnia y Herzegovina', code: '+387' },
    { name: 'Botsuana', code: '+267' },
    { name: 'Brasil', code: '+55' },
    { name: 'Brunéi', code: '+673' },
    { name: 'Bulgaria', code: '+359' },
    { name: 'Burkina Faso', code: '+226' },
    { name: 'Burundi', code: '+257' },
    { name: 'Bután', code: '+975' },
    { name: 'Cabo Verde', code: '+238' },
    { name: 'Camerún', code: '+237' },
    { name: 'Camboya', code: '+855' },
    { name: 'Canadá', code: '+1' },
    { name: 'Katar', code: '+974' },
    { name: 'Kazajistán', code: '+7' },
    { name: 'Chad', code: '+235' },
    { name: 'Chile', code: '+56' },
    { name: 'China', code: '+86' },
    { name: 'Chipre', code: '+357' },
    { name: 'Colombia', code: '+57' },
    { name: 'Comoras', code: '+269' },
    { name: 'Congo', code: '+242' },
    { name: 'Corea del Norte', code: '+850' },
    { name: 'Corea del Sur', code: '+82' },
    { name: 'Costa de Marfil', code: '+225' },
    { name: 'Costa Rica', code: '+506' },
    { name: 'Croacia', code: '+385' },
    { name: 'Cuba', code: '+53' },
    { name: 'Dinamarca', code: '+45' },
    { name: 'Yibuti', code: '+253' },
    { name: 'dominicana', code: '+1-767' },
    { name: 'Egipto', code: '+20' },
    { name: 'El Salvador', code: '+503' },
    { name: 'Emiratos Árabes Unidos', code: '+971' },
    { name: 'Ecuador', code: '+593' },
    { name: 'eritrea', code: '+291' },
    { name: 'Eslovaquia', code: '+421' },
    { name: 'Eslovenia', code: '+386' },
    { name: 'España', code: '+34' },
    { name: 'Estados Unidos', code: '+1' },
    { name: 'Estonia', code: '+372' },
    { name: 'Eswatini', code: '+268' },
    { name: 'Etiopía', code: '+251' },
    { name: 'Fiji', code: '+679' },
    { name: 'Filipinas', code: '+63' },
    { name: 'Finlandia', code: '+358' },
    { name: 'Francia', code: '+33' },
    { name: 'Gabón', code: '+241' },
    { name: 'Gambia', code: '+220' },
    { name: 'Gana', code: '+233' },
    { name: 'Georgia', code: '+995' },
    { name: 'Granada', code: '+1-473' },
    { name: 'Grecia', code: '+30' },
    { name: 'Guatemala', code: '+502' },
    { name: 'Guiana', code: '+592' },
    { name: 'Guinea', code: '+224' },
    { name: 'Guinea Ecuatorial', code: '+240' },
    { name: 'Guinea-Bisáu', code: '+245' },
    { name: 'Haití', code: '+509' },
    { name: 'Países Bajos', code: '+31' },
    { name: 'Honduras', code: '+504' },
    { name: 'Hungría', code: '+36' },
    { name: 'Yemen', code: '+967' },
    { name: 'Islas Caimán', code: '+1-345' },
    { name: 'Islas Cook', code: '+682' },
    { name: 'Islas Marshall', code: '+692' },
    { name: 'Islas Salomón', code: '+677' },
    { name: 'Islas Vírgenes de EE.UU', code: '+1-340' },
    { name: 'islas vírgenes británicas', code: '+1-284' },
    { name: 'India', code: '+91' },
    { name: 'Indonesia', code: '+62' },
    { name: 'Voluntad', code: '+98' },
    { name: 'Irak', code: '+964' },
    { name: 'Irlanda', code: '+353' },
    { name: 'Islandia', code: '+354' },
    { name: 'Israel', code: '+972' },
    { name: 'Italia', code: '+39' },
    { name: 'Jamaica', code: '+1-876' },
    { name: 'Japón', code: '+81' },
    { name: 'Jordán', code: '+962' },
    { name: 'Kiribati', code: '+686' },
    { name: 'Kuwait', code: '+965' },
    { name: 'Laos', code: '+856' },
    { name: 'Lesoto', code: '+266' },
    { name: 'letonia', code: '+371' },
    { name: 'Líbano', code: '+961' },
    { name: 'Libéria', code: '+231' },
    { name: 'Libia', code: '+218' },
    { name: 'Liechtenstein', code: '+423' },
    { name: 'Lituania', code: '+370' },
    { name: 'luxemburgo', code: '+352' },
    { name: 'Madagascar', code: '+261' },
    { name: 'Malasia', code: '+60' },
    { name: 'Malawi', code: '+265' },
    { name: 'Maldivas', code: '+960' },
    { name: 'Mali', code: '+223' },
    { name: 'Malta', code: '+356' },
    { name: 'Marrocos', code: '+212' },
    { name: 'Maurício', code: '+230' },
    { name: 'Mauritânia', code: '+222' },
    { name: 'México', code: '+52' },
    { name: 'Micronésia', code: '+691' },
    { name: 'Mozambique', code: '+258' },
    { name: 'Moldavia', code: '+373' },
    { name: 'Mónaco', code: '+377' },
    { name: 'Mongolia', code: '+976' },
    { name: 'Montenegro', code: '+382' },
    { name: 'Namibia', code: '+264' },
    { name: 'Nauru', code: '+674' },
    { name: 'Nepal', code: '+977' },
    { name: 'Nicaragua', code: '+505' },
    { name: 'Níger', code: '+227' },
    { name: 'Nigeria', code: '+234' },
    { name: 'Niue', code: '+683' },
    { name: 'Noruega', code: '+47' },
    { name: 'Nueva Zelanda', code: '+64' },
    { name: 'Omã', code: '+968' },
    { name: 'Palau', code: '+680' },
    { name: 'Palestina', code: '+970' },
    { name: 'Panamá', code: '+507' },
    { name: 'Papúa Nueva Guinea', code: '+675' },
    { name: 'Pakistán', code: '+92' },
    { name: 'Paraguay', code: '+595' },
    { name: 'Perú', code: '+51' },
    { name: 'Polonia', code: '+48' },
    { name: 'Portugal', code: '+351' },
    { name: 'Kenia', code: '+254' },
    { name: 'Kirguistán', code: '+996' },
    { name: 'Reino Unido', code: '+44' },
    { name: 'República Centroafricana', code: '+236' },
    { name: 'República Dominicana', code: '+1-809, +1-829, +1-849' },
    { name: 'República Checa', code: '+420' },
    { name: 'Rumania', code: '+40' },
    { name: 'Ruanda', code: '+250' },
    { name: 'Rusia', code: '+7' },
    { name: 'Samoa', code: '+685' },
    { name: 'San Marino', code: '+378' },
    { name: 'Santa Lucía', code: '+1-758' },
    { name: 'San Cristóbal y Nieves', code: '+1-869' },
    { name: 'San Tome y Principe', code: '+239' },
    { name: 'San Vicente y las Granadinas', code: '+1-784' },
    { name: 'Senegal', code: '+221' },
    { name: 'Serbia', code: '+381' },
    { name: 'Seychelles', code: '+248' },
    { name: 'Sierra Leona', code: '+232' },
    { name: 'Singapur', code: '+65' },
    { name: 'Siria', code: '+963' },
    { name: 'Somália', code: '+252' },
    { name: 'Sri Lanka', code: '+94' },
    { name: 'Suazilandia', code: '+268' },
    { name: 'Sudán', code: '+249' },
    { name: 'Sudán del Sur', code: '+211' },
    { name: 'Suecia', code: '+46' },
    { name: 'Suiza', code: '+41' },
    { name: 'Surinam', code: '+597' },
    { name: 'tailandia', code: '+66' },
    { name: 'Taiwan', code: '+886' },
    { name: 'Tayikistán', code: '+992' },
    { name: 'Tanzania', code: '+255' },
    { name: 'Timor-Leste', code: '+670' },
    { name: 'Togo', code: '+228' },
    { name: 'Tonga', code: '+676' },
    { name: 'Trinidad e Tobago', code: '+1-868' },
    { name: 'Túnez', code: '+216' },
    { name: 'turkmenistán', code: '+993' },
    { name: 'Turquía', code: '+90' },
    { name: 'Tuvalu', code: '+688' },
    { name: 'Ucrania', code: '+380' },
    { name: 'Uganda', code: '+256' },
    { name: 'Uruguay', code: '+598' },
    { name: 'uzbekistán', code: '+998' },
    { name: 'Vanuatu', code: '+678' },
    { name: 'Vaticano', code: '+379' },
    { name: 'Venezuela', code: '+58' },
    { name: 'Vietnam', code: '+84' },
    { name: 'Zambia', code: '+260' },
    { name: 'Zimbabue', code: '+263' }
  ]
};

const digit = /[0-9]/;
const maskPhoneExtended = [
  '(',
  digit,
  digit,
  /[\d\s]/,
  ')',
  ' ',
  digit,
  digit,
  digit,
  digit,
  digit,
  digit,
  digit,
  digit,
  digit
];

const CustomInputPhone = ({ label, onChange, error, disabled = false }: Props) => {
  const [selectedCountry, setSelectedCountry] = useState<Country>(countriesCode['pt-BR'][2]);
  const { i18n } = useTranslation();
  const [rest, setRest] = useState('');
  const [value, setValue] = useState('');
  const [codes, setCodes] = useState<Country[]>(countriesCode['pt-BR']);
  const [mask, setMask] = useState<any>(maskPhoneExtended);

  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);

  const primaryColor = colors.primary || defaultColors.primary;

  useEffect(() => {
    setCodes(countriesCode[i18n.languages[0] as 'pt-BR' | 'es' | 'en']);
  }, [i18n.languages]);

  useEffect(() => {
    const temp = `${selectedCountry.code} ${rest}`;

    setValue(temp);

    if (onChange) {
      onChange(value);
    }
  }, [selectedCountry, rest]);

  const maskBuilder = (v?: string) => {
    if (selectedCountry.code === '+55') {
      setMask('(99) 999999999');
      return;
    }

    if (!v || v.length == 0 || v.length < 3 || v.length >= 4) return;

    if (v[3] === ' ') {
      setMask('(99) 999999999');
      return;
    }

    setMask(maskPhoneExtended);
  };

  return (
    <div className="flex flex-col w-full gap-1 ">
      <label className={`${error ? 'text-red-500' : primaryColor} text-sm `}>{label}</label>
      <div className="flex items-center w-full gap-2">
        <select
          disabled={disabled}
          defaultValue={selectedCountry.code}
          className="border-[1px] h-[40px] px-4 border-[#CED4DA] rounded-lg w-3/12 "
          onChange={(e) => {
            maskBuilder('');
            setSelectedCountry(codes[e.target.selectedIndex]);
          }}
        >
          {codes.map((country, index) => (
            <option value={country.code} key={index}>
              {toTitleCase(country.name || '')}
            </option>
          ))}
        </select>

        <div className="flex items-center px-4  w-full border-[1px] border-[#CED4DA] h-[40px] rounded-lg ">
          <span className="w-auto whitespace-nowrap">{selectedCountry.code}</span>

          {/* TODO: caracteres opcionais */}
          <ReactInputMask
            mask={mask}
            disabled={disabled}
            className="w-full pl-2 hover:outline-none focus-within:outline-none"
            value={rest}
            beforeMaskedStateChange={({ currentState, nextState }) => {
              maskBuilder(currentState?.value);
              return nextState;
            }}
            onChange={(e) => setRest(e.currentTarget.value)}
          />
        </div>
      </div>
      <span className="h-0 text-xs text-red-500">{error}</span>
    </div>
  );
};

export { CustomInputPhone };
